interface ILinkList {
    url: string; //without https://
    title: string;
    active?: boolean;
}

const listOfLink: ILinkList[] = [
    {
        url: 'https://drive.google.com/drive/folders/1MJkXC7IDmwRfp2ruhEEkS9LXjMuO2owF?usp=sharing',
        title: 'materi custom class II (sebelumnya) ',
        active: true
    },
    {
        url: 'https://forms.gle/niPszxxbhmNofeay7',
        title: 'pendaftaran customs class III',
        active: true
    }, {
        url: 'https://us06web.zoom.us/j/85193281970?pwd=6J6jonDQXDr7FcJcPfPBCL4zsKidSN.1',
        title :'link zoom',
        active: true
    },
    {
        url: 'https://youtube.com/live/abmf0LC7EVI?feature=share',
        title: 'link live streaming',
        active: true
    },
    {
        url: '/img/bg_zoom.png',
        title: 'background zoom',
        active: true
    }, 
    {
        url: 'https://app.sli.do/event/wR8RbYG83NhuJqupNXRXVM',
        title: 'slido',
        active: true
    },
    {
        url: 'https://forms.gle/GDCNS7Ac9rvtBowH9',
        title: 'presensi',
        active: true
    }, {
        url: 'https://forms.gle/K6dTVN8tqB6zbPWZA',
        title: 'evaluasi',
        active: true
    }, {
        url: 'https://www.instagram.com/pskc_pknstan',
        title: 'follow instagram PSKC',
        active: true
    }
]


export default listOfLink;